// src/components/ModeToggle.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { isOnlineMode, setOnlineMode } from "../../utils/onlineStatus";

export default function ModeToggle() {
  const [online, setOnline] = useState(isOnlineMode());

  useEffect(() => {
    setOnline(isOnlineMode());
  }, []);

  const toggleMode = () => {
    const newMode = !online;
    setOnline(newMode);
    setOnlineMode(newMode);
  };

  return (
    <ToggleContainer onClick={toggleMode} online={online}>
      <Switch online={online} />
      <Label>{online ? "Online" : "Offline"}</Label>
    </ToggleContainer>
  );
}

// ---------- Styled Components ----------
const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: ${({ online }) => (online ? "#d4f5d0" : "#f5d0d0")};
  border-radius: 20px;
  padding: 4px 8px;
  width: 120px;
  justify-content: space-between;
`;

const Switch = styled.div`
  width: 20px;
  height: 20px;
  background: ${({ online }) => (online ? "#00a000" : "#a00000")};
  border-radius: 50%;
  transition: background 0.2s;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;
